module.exports = __webpack_public_path__ + "img/bug.4ab9616f.svg";